import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { JWTProvider } from "./contexts/JWTContext";

import Navbar from "./components/common/Navbar";
import Toast from "./components/common/Toast";
import { ToastProvider } from "./contexts/ToastContext";

import Course from "./pages/course/ListCoursePage";
import Battle from "./pages/battle/ListBattlePage";
import WorkRecord from "./pages/workrecord/ListWorkRecordPage";
import User from "./pages/user/GetUser";

import Start from "./pages/Start";
import Home from "./pages/Home";

import Login from "./pages/user/Login";
import AddUser from "./pages/user/AddUser";
import UpdateUser from "./pages/user/UpdateUser";

import AddCoursePage from "./pages/course/AddCoursePage";
import AddingCoursePage from "./pages/course/AddingCoursePage";
import GetCoursePage from "./pages/course/GetCoursePage";
import UseingCoursePage from "./pages/course/UseingCoursePage";
import AddAndUpdateReviewPage from "./pages/course/AddAndUpdateReviewPage";

import ListBattlePage from "./pages/battle/ListBattlePage";
import AddBattlePage from "./pages/battle/AddBattlePage";
import GetBattlePage from "./pages/battle/GetBattlePage";
import TopBattlePage from "./pages/battle/TopBattlePage";
import MyBattleListPage from "./pages/battle/MyBattleListPage";

import ListWorkRecordPage from "./pages/workrecord/ListWorkRecordPage";
import GetWorkRecordPage from "./pages/workrecord/GetWorkRecordPage";
import StatsWorkRecordPage from "./pages/workrecord/StatsWorkRecordPage";


function Layout({ children }) {
  const location = useLocation();

  // 하단 네비 숨길 페이지들
  const hideNavbarPaths = ["/", "/login", "/signup"];

  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);

  return (
    <>
      {children}
      {!shouldHideNavbar && <Navbar />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <JWTProvider>
        <ToastProvider>
          <Layout>
            <Toast />
            <Routes>

              {/* NavBar 라우터 */}
              <Route path="/course" element={<Course />} />
              <Route path="/battle" element={<Battle />} />
              <Route path="/workrecord" element={<WorkRecord />} />
              <Route path="/user" element={<User />} />

              {/* 공통 라우터 */}
              <Route path="/" element={<Start />} />

              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />

              {/* 회원 */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<AddUser />} />
              <Route path="/update" element={<UpdateUser />} />

              {/* 코스 */}
              <Route path="/course/add" element={<AddCoursePage />} />
              <Route path="/course/adding" element={<AddingCoursePage />} />
              <Route path="/course/:courseId" element={<GetCoursePage />} />
              <Route path="/course/using" element={<UseingCoursePage />} />
              <Route
                path="/course/:courseId/reviews/add"
                element={<AddAndUpdateReviewPage />}
              />
              <Route
                path="/course/:courseId/reviews/:reviewId/edit"
                element={<AddAndUpdateReviewPage />}
              />

              {/* 대결 */}
              <Route path="/battle/list" element={<ListBattlePage />} />
              <Route path="/battle/add" element={<AddBattlePage />} />
              <Route path="/battle/top" element={<TopBattlePage />} />
              <Route path="/battle/getBattle" element={<GetBattlePage />} />
              <Route path="/battle/my" element={<MyBattleListPage />} />

              {/* 운동기록 */}
              <Route path="/workrecord/stats/:userId" element={<StatsWorkRecordPage />} />
              <Route path="/workrecord/get/:workRecordId" element={<GetWorkRecordPage />} />
              <Route path="/workrecord/list" element={<ListWorkRecordPage />} />
            </Routes>
          </Layout>
        </ToastProvider>
      </JWTProvider>
    </BrowserRouter>
  );
}

export default App;
